import { render, staticRenderFns } from "./RequestDocumentation.vue?vue&type=template&id=34a5816e&"
import script from "./RequestDocumentation.vue?vue&type=script&lang=js&"
export * from "./RequestDocumentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports